// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"ContactPage_bannerWrapper__vWcdo","BannerImage":"ContactPage_BannerImage__WAQ-O","header":"ContactPage_header__nfUeb"};